import { Button } from 'antd'
import styles from './index.less'

export default props => {
    return (
        <Button type="link" className={styles.container} {...props}>
            筛选项排序
        </Button>
    )
}
